import { fetchConfig } from "./actions";
import { connect } from "react-redux";

export const withConfig = connect(
  state => {
    return {
      ...state.config
    };
  },
  dispatch => ({
    fetchConfig: () => dispatch(fetchConfig())
  })
);



// WEBPACK FOOTER //
// ./src/app/config/hocs.js